import React from 'react';
export function Footer() {
  return <footer className="bg-navy-dark py-8 border-t border-navy-light text-center px-4" data-id="element-129">
      <div className="max-w-4xl mx-auto" data-id="element-130">
        <p className="text-white/50 text-sm mb-2" data-id="element-131">
          © {new Date().getFullYear()} Spanish Ready™ — All rights reserved.
        </p>
        <p className="text-white/40 text-xs" data-id="element-132">
          For department licenses, school packages, and bulk orders:
          hello@spanishready.com
        </p>
      </div>
    </footer>;
}